import PlanDetectionProvider from "@/models/enums/plan-detection-provider";
import PlanDetectionStatus from "@/models/enums/plan-detection-status";
import { JobAdapter, UnifiedJobStatus } from "../job";

export default interface PlanDetectionTaskDTO {
    projectId: string,
    taskId: string,
    provider: PlanDetectionProvider,
    status: PlanDetectionStatus,
    createdAt: string,
    generatedAt: string,
    error: string
}

export const planDetectionTaskAdapter: JobAdapter<PlanDetectionTaskDTO> = {
    getId: (task) => task.taskId,
    getStatus: (task) => {
        switch (task.status) {
            case PlanDetectionStatus.Pending:
                return UnifiedJobStatus.Pending;
            case PlanDetectionStatus.Running:
                return UnifiedJobStatus.Processing;
            case PlanDetectionStatus.Completed:
                return UnifiedJobStatus.Success;
            case PlanDetectionStatus.Failed:
                return UnifiedJobStatus.Error;
            default:
                return UnifiedJobStatus.Error;
        }
    },
    getProjectId: (task) => task.projectId
};